import { some } from 'lodash'
import { legacyProducts } from './legacyProducts'

/**
 * This function will determine if the product is a small business product
 * By checking if the product name or id includes 'smallbusiness'
 * @param {object} product - product object
 * @returns true if the product is a small business product
 */
export const isSmallBusinessProduct = (product) =>
  product?.id?.includes('smallbusiness') || product?.id?.includes('_s_')

/**
 * This function will determine if the product is an annual product
 * @param {object} product - product object
 * @returns true if the product is an annual product
 */
export const isAnnualProduct = (product) => product?.id?.includes('months12')

/**
 * This function will determine if the product is an overage product
 * @param {object} product - product object
 * @returns true if the product is an annual product
 */
export const isOverageProduct = (product) => product?.id?.includes('credits1_overage_v1')

/**
 * This function will determine if the product is an overage product
 * @param {object} product - product object
 * @returns true if the product is an annual product
 */
export const isSupportProduct = (product) => product?.id?.includes('premium_support_v1')

/**
 * This function will determine if the product is a pay up front product
 * @param {object} product - product object
 * @returns true if the product is a pay up front product
 */
export const isPayUpFrontProduct = (product) => product?.id?.includes('upfront')

/**
 * This function will determine if the product is an unlimited product
 * @param {object} product - product object
 * @returns true if the product is an unlimited product
 */
export const isUnlimitedProduct = (product) => product?.id?.includes('credits_unlimited_v1')

/**
 * This function will determine if the product is a legacy product
 * By checking if the product id is included in the legacyProducts array
 * @param {object} product - product object
 * @returns true if the product is a legacy product
 */
export const isLegacyProduct = (product) => {
  return some(legacyProducts, (n) => n.id === product?.id)
}

/**
 * Checks if the product ID matches the specified credit units.
 * @param {string} id - Product ID to check
 * @returns {boolean} - Whether the product ID matches the unit condition
 */
export const isValidCreditUnit = (product) => {
  const validUnits = ['credits15_', 'credits50_', 'credits300_']
  return validUnits.some((unit) => product?.id?.includes(unit))
}
